<template>
  <div class="order-page">
    <!-- 🔹 필터 영역 -->
    <div class="filter-header">
      <el-button
        type="success"
        @click="$router.push('/v2/monitoring')"
        size="small"
      >
        모니터링 페이지로 이동
      </el-button>
    </div>
    <el-card class="filter-section" shadow="hover">
      <div class="filter-row">
        <el-date-picker
          v-model="fromDate"
          type="date"
          placeholder="시작일"
          style="width: 180px"
        />
        <span class="date-divider">~</span>
        <el-date-picker
          v-model="toDate"
          type="date"
          placeholder="종료일"
          style="width: 180px"
        />

        <el-select
          v-model="orderState"
          placeholder="주문 상태"
          style="width: 200px"
        >
          <el-option label="전체" :value="0"></el-option>
          <el-option label="운행완료" :value="10156"></el-option>
          <el-option label="취소" :value="10157"></el-option>
          <el-option label="유상취소" :value="10165"></el-option>
        </el-select>
        <el-select
          v-model="reqType"
          placeholder="주문 요청 구분"
          style="width: 200px"
        >
          <el-option label="전체" :value="0"></el-option>
          <el-option label="주문마감" :value="1"></el-option>
          <el-option label="청구요청" :value="2"></el-option>
          <el-option label="청구확정" :value="3"></el-option>
          <el-option label="청구마감" :value="4"></el-option>
          <el-option label="청구반송" :value="5"></el-option>
          <el-option label="청구제외" :value="6"></el-option>
        </el-select>

        <el-select
          v-model="dateType"
          placeholder="주문 기준"
          style="width: 200px"
        >
          <el-option label="주문 접수일" :value="1"></el-option>
          <el-option label="주문 운행완료일" :value="2"></el-option>
          <el-option label="주문 마감일" :value="3"></el-option>
          <el-option label="청구 요청일" :value="4"></el-option>
          <el-option label="청구 확정일" :value="5"></el-option>
          <el-option label="청구 마감일" :value="6"></el-option>
          <el-option label="청구 반송일" :value="7"></el-option>
        </el-select>

        <el-input
          v-model="keyword"
          placeholder="키워드를 입력하세요"
          clearable
          prefix-icon="el-icon-search"
          style="width: 100%"
        >
          <el-button
            slot="append"
            type="primary"
            @click="fetchData"
            v-loading.fullscreen.lock="searchLoading"
            >검색</el-button
          >
        </el-input>
      </div>
    </el-card>

    <!-- 🔹 테이블 영역 -->
    <el-card class="table-section" shadow="hover">
      <div
        style="display: flex; align-items: center; justify-content: space-between;"
      >
        <div
          style="display: flex; gap: 30px; align-items: center; margin-bottom: 10px;"
        >
          <span>총 {{ totalOrderData }} 건</span>
          <span>{{ multipleTableData.length }} 건 선택됨</span>
          <div style="display: flex; gap: 5px;">
            <el-button
              style="justify-content: end;"
              @click="orderListBillingCall()"
              :disabled="multipleTableData.length === 0"
              >선택된 주문 청구요청</el-button
            >
            <!-- <el-button
              style="justify-content: end;"
              @click="orderListBillingCall()"
              :disabled="multipleTableData.length === 0"
              >선택된 주문 청구대기</el-button
            > -->
            <el-button
              style="justify-content: end;"
              type="primary"
              @click="ExcelDownload()"
              v-loading.fullscreen.lock="ExcelLoading"
              >엑셀 다운로드</el-button
            >
          </div>
        </div>
        <div class="status-badges">
          <span class="badge badge-default"
            >요청전 {{ statusCounts.bs00 }} 건</span
          >
          <span class="badge badge-blue">요청 {{ statusCounts.bs01 }} 건</span>
          <span class="badge badge-green">확정 {{ statusCounts.bs02 }} 건</span>
          <span class="badge badge-purple"
            >마감 {{ statusCounts.bs03 }} 건</span
          >
          <span class="badge badge-red">반송 {{ statusCounts.bs04 }} 건</span>
          <!-- <span class="badge badge-dark">제외 {{ statusCounts.bs99 }} 건</span> -->
        </div>
      </div>
      <!-- 엑셀 출력 테이블 -->
      <el-table
        :data="excelTableData"
        border
        highlight-current-row
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
        id="list-table"
        v-show="false"
      >
        <!-- <el-table-column align="center" width="160" label="상황실">
          <template slot-scope="scope">
            <div class="confirmState">
              <el-form>
                <el-input
                  type="text"
                  style="width: 100%; border-color: red; text-align: center;"
                  v-model="$store.getters.userAccount.name"
                  disabled
                />
                <el-button
                  @click="billingCall(scope.row)"
                  style="width: 100%; margin-top: 10px;"
                  type="success"
                  plain
                  :disabled="scope.row.state !== 'BS00'"
                  >청구요청</el-button
                >
              </el-form>
            </div>
          </template>
        </el-table-column> -->
        <!-- 🔹 기본 컬럼들 -->

        <el-table-column prop="orderNo" label="주문번호" width="100" />
        <el-table-column prop="state" label="청구상태" width="80">
          <template slot-scope="scope">
            <div>
              {{ scope.row.state | billingStateToName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderState" label="주문상태" width="90">
          <template slot-scope="scope">
            <div>
              {{ scope.row.orderState | orderStateToName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transNo" label="연동번호" width="110" />
        <el-table-column prop="orderDate" label="주문 접수일" width="100">
          <template slot-scope="scope" v-if="scope.row.orderDate !== null">
            {{ scope.row.orderDate.split(" ")[0] }} <br />
            {{ scope.row.orderDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column prop="orderDate" label="주문 마감일" width="100">
          <template slot-scope="scope" v-if="scope.row.orderCloseDate !== null">
            {{ scope.row.orderCloseDate.split(" ")[0] }} <br />
            {{ scope.row.orderCloseDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column
          prop="orderCompleteDate"
          label="운행 완료일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.orderCompleteDate !== null"
          >
            {{ scope.row.orderCompleteDate.split(" ")[0] }} <br />
            {{ scope.row.orderCompleteDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <!-- <el-table-column prop="vendorNo" label="지사번호" width="140" /> -->
        <!-- <el-table-column prop="vendorName" label="지사이름" width="140" /> -->

        <!-- <el-table-column prop="code" label="응답코드" width="140" /> -->
        <!-- <el-table-column prop="message" label="응답메시지" width="140" /> -->
        <el-table-column prop="carNo" label="차량번호" width="90" />
        <el-table-column prop="carModel" label="차종" width="100" />
        <el-table-column prop="distance" label="운행거리" width="100" sortable>
          <template slot-scope="scope"> {{ scope.row.distance }} km </template>
        </el-table-column>
        <el-table-column prop="baseFee" label="기본요금" width="100" sortable>
          <template slot-scope="scope">
            {{ scope.row.baseFee | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="addCharge"
          label="추가요금 (추가거리)"
          width="150"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.addCharge | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="outOfAreaCharge"
          label="오지요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.outOfAreaCharge | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="earlyMorningCharge"
          label="조조요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.earlyMorningCharge | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="waitingCharge"
          label="대기요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.waitingCharge | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cancellationFee"
          label="취소요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.cancellationFee | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="otherCharges"
          label="기타요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.otherCharges | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="actualCost"
          label="공급가액"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.actualCost | comma }}
          </template>
        </el-table-column>
        <!-- 값 다시 넣어주기 -->
        <el-table-column prop="fuelCost" label="주유비" width="100" sortable>
          <template slot-scope="scope">
            {{ scope.row.fuelCost | comma }}
          </template>
        </el-table-column>
        <el-table-column prop="tollFee" label="톨게이트비" width="110" sortable>
          <template slot-scope="scope">
            {{ scope.row.tollFee | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="additionalAmount"
          label="기타부대비용"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.additionalAmount | comma }}
          </template>
        </el-table-column>
        <!-- 값 다시 넣어주기 -->
        <el-table-column
          prop="extraCost"
          label="부대비용 소계"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.extraCost | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="managerName"
          label="청구 요청 담당자명"
          width="120"
        />
        <el-table-column
          prop="billingRequestDate"
          label="청구 요청일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.billingRequestDate !== null"
          >
            {{ scope.row.billingRequestDate.split(" ")[0] }} <br />
            {{ scope.row.billingRequestDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column
          prop="billingReturnDate"
          label="청구 반송일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.billingReturnDate !== null"
          >
            {{ scope.row.billingReturnDate.split(" ")[0] }} <br />
            {{ scope.row.billingReturnDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column
          prop="billingConfirmationDate"
          label="청구 확정일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.billingConfirmationDate !== null"
          >
            {{ scope.row.billingConfirmationDate.split(" ")[0] }} <br />
            {{ scope.row.billingConfirmationDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column prop="billingDueDate" label="청구 마감일" width="100">
          <template slot-scope="scope" v-if="scope.row.billingDueDate !== null">
            {{ scope.row.billingDueDate.split(" ")[0] }} <br />
            {{ scope.row.billingDueDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column prop="outOfAreaMemo" label="오지요금 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.outOfAreaMemo ? scope.row.outOfAreaMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="earlyMorningMemo"
          label="조조요금 메모"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.earlyMorningMemo ? scope.row.earlyMorningMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cancellationMemo"
          label="취소요금 메모"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.cancellationMemo ? scope.row.cancellationMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="otherMemo" label="기타요금 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.otherMemo ? scope.row.otherMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="fuelMemo" label="주유비 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.fuelMemo ? scope.row.fuelMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="tollMemo" label="톨게이트비 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.tollMemo ? scope.row.tollMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="additionalMemo"
          label="기타부대비용 메모"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.additionalMemo ? scope.row.additionalMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="standbyCode" label="대기사유 코드" width="100">
          <template slot-scope="scope">
            {{ scope.row.standbyCode | standbyCodeToName }}
          </template>
        </el-table-column>
        <el-table-column prop="waitingMemo" label="대기사유 메모" width="200">
          <template slot-scope="scope">
            {{ scope.row.waitingMemo ? scope.row.waitingMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="memo" label="메모" width="1000">
          <template slot-scope="scope">
            {{ scope.row.memo ? scope.row.memo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="returnList" label="청구 반송 내역" width="200">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.returnList" :key="index">
              <span> {{ item.reason }} : {{ item.detail }} </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 화면 출력 테이블 -->
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          type="selection"
          align="center"
          width="55"
          :selectable="checkSelectable"
        />
        <!-- ✅ 행 클릭시 펼쳐지는 확장 컬럼 -->
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand-box">
              <p class="expand-title">부대비용 영수증 사진</p>

              <div class="image-gallery">
                <!-- ✅ 이미지 배열이 없거나 비어 있을 때 예외 처리 -->
                <div
                  v-if="
                    !props.row.imageList || props.row.imageList.length === 0
                  "
                  class="no-image"
                >
                  등록된 영수증 이미지가 없습니다.
                </div>

                <!-- ✅ 안정적인 이미지 카드 반복 렌더링 -->
                <div
                  class="image-card"
                  v-for="(img, idx) in props.row.imageList"
                  :key="idx"
                >
                  <p class="img-name">{{ img.name }}</p>

                  <el-image
                    :src="img.path"
                    fit="cover"
                    :preview-src-list="props.row.imageList.map(i => i.path)"
                    class="preview-img"
                  />
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" width="160" label="상황실">
          <template slot-scope="scope">
            <div class="confirmState">
              <el-form>
                <el-input
                  type="text"
                  style="width: 100%; border-color: red; text-align: center;"
                  v-model="$store.getters.userAccount.name"
                  disabled
                />
                <el-button
                  @click="billingCall(scope.row)"
                  style="width: 100%; margin-top: 10px;"
                  type="success"
                  plain
                  :disabled="scope.row.state !== 'BS00'"
                  >청구요청</el-button
                >
              </el-form>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" width="100" label="청구 이력 수정">
          <template slot-scope="scope">
            <el-button
              :disabled="
                scope.row.state !== 'BS00' && scope.row.state !== 'BS04'
              "
              @click="billingUpdateVisible(scope.row)"
              >수정</el-button
            >
          </template>
        </el-table-column>
        <!-- 🔹 기본 컬럼들 -->

        <el-table-column prop="orderNo" label="주문번호" width="100" />
        <el-table-column prop="state" label="청구상태" width="80">
          <template slot-scope="scope">
            <div>
              {{ scope.row.state | billingStateToName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orderState" label="주문상태" width="90">
          <template slot-scope="scope">
            <div>
              {{ scope.row.orderState | orderStateToName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transNo" label="연동번호" width="110" />
        <el-table-column prop="orderDate" label="주문 접수일" width="100">
          <template slot-scope="scope" v-if="scope.row.orderDate !== null">
            {{ scope.row.orderDate.split(" ")[0] }} <br />
            {{ scope.row.orderDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column prop="orderDate" label="주문 마감일" width="100">
          <template slot-scope="scope" v-if="scope.row.orderCloseDate !== null">
            {{ scope.row.orderCloseDate.split(" ")[0] }} <br />
            {{ scope.row.orderCloseDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column
          prop="orderCompleteDate"
          label="운행 완료일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.orderCompleteDate !== null"
          >
            {{ scope.row.orderCompleteDate.split(" ")[0] }} <br />
            {{ scope.row.orderCompleteDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <!-- <el-table-column prop="vendorNo" label="지사번호" width="140" /> -->
        <!-- <el-table-column prop="vendorName" label="지사이름" width="140" /> -->

        <!-- <el-table-column prop="code" label="응답코드" width="140" /> -->
        <!-- <el-table-column prop="message" label="응답메시지" width="140" /> -->

        <el-table-column prop="carNo" label="차량번호" width="90" />
        <el-table-column prop="carModel" label="차종" width="100" />
        <el-table-column prop="distance" label="운행거리" width="100" sortable>
          <template slot-scope="scope"> {{ scope.row.distance }} km </template>
        </el-table-column>
        <el-table-column prop="baseFee" label="기본요금" width="100" sortable>
          <template slot-scope="scope">
            {{ scope.row.baseFee | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="addCharge"
          label="추가요금 (추가거리)"
          width="150"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.addCharge | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="outOfAreaCharge"
          label="오지요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.outOfAreaCharge | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="earlyMorningCharge"
          label="조조요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.earlyMorningCharge | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="waitingCharge"
          label="대기요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.waitingCharge | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cancellationFee"
          label="취소요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.cancellationFee | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="otherCharges"
          label="기타요금"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.otherCharges | comma }}
          </template>
        </el-table-column>
        <el-table-column
          prop="actualCost"
          label="공급가액"
          width="100"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.actualCost | comma }}
          </template>
        </el-table-column>
        <!-- 값 다시 넣어주기 -->
        <el-table-column prop="fuelCost" label="주유비" width="100" sortable>
          <template slot-scope="scope">
            {{ scope.row.fuelCost | comma }}
          </template>
        </el-table-column>
        <el-table-column prop="tollFee" label="톨게이트비" width="110" sortable>
          <template slot-scope="scope">
            {{ scope.row.tollFee | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="additionalAmount"
          label="기타부대비용"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.additionalAmount | comma }}
          </template>
        </el-table-column>
        <!-- 값 다시 넣어주기 -->
        <el-table-column
          prop="extraCost"
          label="부대비용 소계"
          width="120"
          sortable
        >
          <template slot-scope="scope">
            {{ scope.row.extraCost | comma }}
          </template>
        </el-table-column>

        <el-table-column
          prop="managerName"
          label="청구 요청 담당자명"
          width="120"
        />
        <el-table-column
          prop="billingRequestDate"
          label="청구 요청일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.billingRequestDate !== null"
          >
            {{ scope.row.billingRequestDate.split(" ")[0] }} <br />
            {{ scope.row.billingRequestDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column
          prop="billingReturnDate"
          label="청구 반송일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.billingReturnDate !== null"
          >
            {{ scope.row.billingReturnDate.split(" ")[0] }} <br />
            {{ scope.row.billingReturnDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>

        <el-table-column
          prop="billingConfirmationDate"
          label="청구 확정일"
          width="100"
        >
          <template
            slot-scope="scope"
            v-if="scope.row.billingConfirmationDate !== null"
          >
            {{ scope.row.billingConfirmationDate.split(" ")[0] }} <br />
            {{ scope.row.billingConfirmationDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column prop="billingDueDate" label="청구 마감일" width="100">
          <template slot-scope="scope" v-if="scope.row.billingDueDate !== null">
            {{ scope.row.billingDueDate.split(" ")[0] }} <br />
            {{ scope.row.billingDueDate.split(" ")[1].split(".")[0] }}
          </template>
          <template v-else>
            -
          </template>
        </el-table-column>
        <el-table-column prop="outOfAreaMemo" label="오지요금 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.outOfAreaMemo ? scope.row.outOfAreaMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="earlyMorningMemo"
          label="조조요금 메모"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.earlyMorningMemo ? scope.row.earlyMorningMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="cancellationMemo"
          label="취소요금 메모"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.cancellationMemo ? scope.row.cancellationMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="otherMemo" label="기타요금 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.otherMemo ? scope.row.otherMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="fuelMemo" label="주유비 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.fuelMemo ? scope.row.fuelMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="tollMemo" label="톨게이트비 메모" width="150">
          <template slot-scope="scope">
            {{ scope.row.tollMemo ? scope.row.tollMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="additionalMemo"
          label="기타부대비용 메모"
          width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.additionalMemo ? scope.row.additionalMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="standbyCode" label="대기사유 코드" width="100">
          <template slot-scope="scope">
            {{ scope.row.standbyCode | standbyCodeToName }}
          </template>
        </el-table-column>
        <el-table-column prop="waitingMemo" label="대기사유 메모" width="200">
          <template slot-scope="scope">
            {{ scope.row.waitingMemo ? scope.row.waitingMemo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="memo" label="메모" width="1000">
          <template slot-scope="scope">
            {{ scope.row.memo ? scope.row.memo : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="returnList" label="청구 반송 내역" width="200">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.returnList" :key="index">
              <span> {{ item.reason }} : {{ item.detail }} </span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 🔹 페이지네이션 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :total="totalOrderData"
          :page-size="perPageCount"
          :current-page.sync="currentPage"
          @current-change="fetchData"
        />
      </div>
    </el-card>
    <el-dialog
      width="50%"
      title="청구 이력 수정"
      :visible.sync="billingUpdateDialogVisible"
      append-to-body
    >
      <div class="fee-form-container">
        <!-- 조조요금 -->
        <el-form label-width="120px">
          <el-form-item label="오지요금">
            <el-input
              type="number"
              v-model="form.outOfAreaCharge"
              placeholder="오지요금을 입력하세요"
            />
          </el-form-item>
          <el-form-item label="오지요금 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.outOfAreaMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>
          <el-form-item label="조조요금">
            <el-input
              type="number"
              v-model="form.earlyMorningCharge"
              placeholder="조조요금을 입력하세요"
            />
          </el-form-item>
          <el-form-item label="조조요금 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.earlyMorningMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>

          <!-- 대기요금 -->
          <el-form-item label="대기요금">
            <el-input
              type="number"
              v-model="form.waitingCharge"
              placeholder="대기요금을 입력하세요"
            />
          </el-form-item>
          <el-form-item label="대기요금 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.waitingMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>

          <!-- 취소요금 -->
          <el-form-item label="취소요금">
            <el-input
              type="number"
              v-model="form.cancellationFee"
              placeholder="취소요금을 입력하세요"
            />
          </el-form-item>
          <el-form-item label="취소요금 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.cancellationMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>

          <!-- 기타요금 -->
          <el-form-item label="기타요금">
            <el-input
              type="number"
              v-model="form.otherCharges"
              placeholder="기타요금을 입력하세요"
            />
          </el-form-item>
          <el-form-item label="기타요금 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.otherMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>

          <!-- 주유비 -->
          <el-form-item label="주유비">
            <el-input
              type="number"
              v-model="form.fuelCost"
              placeholder="주유비를 입력하세요"
            />
          </el-form-item>
          <el-form-item label="주유비 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.fuelMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>

          <!-- 톨게이트비 -->
          <el-form-item label="톨게이트비">
            <el-input
              type="number"
              v-model="form.tollFee"
              placeholder="톨게이트비를 입력하세요"
            />
          </el-form-item>
          <el-form-item label="톨게이트비 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.tollMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>

          <!-- 기타부대비용 -->
          <el-form-item label="기타부대비용">
            <el-input
              type="number"
              v-model="form.additionalAmount"
              placeholder="기타부대비용 입력"
            />
          </el-form-item>
          <el-form-item label="기타부대비용 메모">
            <el-input
              type="textarea"
              :rows="2"
              v-model="form.additionalMemo"
              placeholder="메모를 입력하세요"
            />
          </el-form-item>
        </el-form>
      </div>

      <!-- Footer -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="onCancel">Cancel</el-button>
        <el-button type="primary" @click="billingUpdate()">저장하기</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dateFormatter } from "@/utils/formatter/date";
import BillingApi from "../api/billing";
import dayjs from "dayjs";
import { comma } from "../utils/rocket-code";
import XLSX from "xlsx";

export default {
  name: "OrderPage",
  data() {
    return {
      billingUpdateDialogVisible: false,
      form: {
        orderNo: null,
        managerName: "",
        outOfAreaCharge: 0,
        outOfAreaMemo: "",
        earlyMorningCharge: 0,
        earlyMorningMemo: "",
        waitingCharge: 0,
        waitingMemo: "",
        cancellationFee: 0,
        cancellationMemo: "",
        otherCharges: 0,
        otherMemo: "",
        fuelCost: 0,
        fuelMemo: "",
        tollFee: 0,
        tollMemo: "",
        additionalAmount: 0,
        additionalMemo: ""
      },
      statusCounts: {
        BS00: 0,
        BS01: 0,
        BS02: 0,
        BS03: 0,
        BS04: 0,
        BS99: 0
      },
      fromDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        21,
        0,
        0,
        0
      ),
      toDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        22,
        0,
        0,
        0
      ),
      orderState: 0,
      reqType: 0,
      dateType: 1,
      keyword: "",
      currentPage: 1,
      perPageCount: 50,
      totalOrderData: 0,
      searchLoading: false,
      ExcelLoading: false,
      tableData: [],
      excelTableData: [],
      multipleTableData: []
    };
  },
  created() {
    this.fetchData();
  },
  computed: {},
  methods: {
    async billingUpdate() {
      await BillingApi.billingUpdate(this.form)
        .then(res => {
          console.log(res);
          this.fetchData();
          this.$message({
            message: "이력수정 성공!",
            type: "success"
          });
          this.onCancel();
        })
        .catch(err => {
          console.log(err);
          this.$message({
            message: "이력수정 실패!",
            type: "error"
          });
          this.onCancel();
        });
    },
    onCancel() {
      this.billingUpdateDialogVisible = false;
    },
    billingUpdateVisible(value) {
      this.form.orderNo = value.orderNo;
      this.form.managerName = this.$store.getters.userAccount.name;
      this.form.outOfAreaCharge = value.outOfAreaCharge;
      this.form.outOfAreaMemo = value.outOfAreaMemo;
      this.form.earlyMorningCharge = value.earlyMorningCharge;
      this.form.earlyMorningMemo = value.earlyMorningMemo;
      this.form.waitingCharge = value.waitingCharge;
      this.form.waitingMemo = value.waitingMemo;
      this.form.cancellationFee = value.cancellationFee;
      this.form.cancellationMemo = value.cancellationMemo;
      this.form.otherCharges = value.otherCharges;
      this.form.otherMemo = value.otherMemo;
      this.form.fuelCost = value.fuelCost;
      this.form.fuelMemo = value.fuelMemo;
      this.form.tollFee = value.tollFee;
      this.form.tollMemo = value.tollMemo;
      this.form.additionalAmount = value.additionalAmount;
      this.form.additionalMemo = value.additionalMemo;
      this.billingUpdateDialogVisible = true;
    },
    checkSelectable(row, index) {
      return row.state === "BS00"; // BS00일 때만 체크 가능
    },
    ExcelDownload() {
      this.ExcelLoading = true;
      var excelData = XLSX.utils.table_to_sheet(
        document.getElementById("list-table"),
        { raw: true }
      );
      var workBook = XLSX.utils.book_new(); // 새 시트 생성
      XLSX.utils.book_append_sheet(workBook, excelData, "정산내역"); // 시트 명명, 데이터 지정
      XLSX.writeFile(workBook, "정산내역.xlsx"); // 엑셀파일 만듬
      setInterval(() => {
        this.ExcelLoading = false;
        this.ExcelButton = false;
      }, 3000);
    },
    tableRowClassName({ row, rowIndex }) {
      //       청구 상태
      // BS00 : 요청전(cs마감)
      // BS01 : 요청
      // BS02 : 확정
      // BS03 : 마감
      // BS04 : 반송
      // BS99 : 제외
      switch (row.state) {
        case "BS00":
          return "badge-default";
        case "BS01":
          return "badge-blue";
        case "BS02":
          return "badge-green";
        case "BS03":
          return "badge-purple";
        case "BS04":
          return "badge-red";
        case "BS99":
          return "badge-dark";
      }
    },
    async orderListBillingCall() {
      this.searchLoading = true;
      const requestBody = {
        orderNoList: this.multipleTableData,
        managerName: this.$store.getters.userAccount.name
      };

      return await BillingApi.getOrderListLotteBillingCall(requestBody)
        .then(() => {
          this.$message({
            message: "청구요청 성공!",
            type: "success"
          });
          this.fetchData();
        })
        .catch(() => {
          this.fetchData();
          this.$message({
            message: "청구요청 실패!",
            type: "error"
          });
        });
    },
    handleSelectionChange(val) {
      let orderNo = 0;
      let orderNoList = [];
      for (let i = 0; i < val.length; i++) {
        orderNo = val[i].orderNo;
        if (val[i].state === "BS00") orderNoList.push(orderNo);
      }
      this.multipleTableData = orderNoList;
    },
    async billingCall(value) {
      this.searchLoading = true;
      const requestBody = {
        orderNo: value.orderNo,
        managerName: this.$store.getters.userAccount.name
      };

      return await BillingApi.getLotteBillingCall(requestBody)
        .then(async () => {
          await this.fetchData();
          this.$message({
            message: "청구요청 성공!",
            type: "success"
          });
        })
        .catch(async () => {
          await this.fetchData();
          this.$message({
            message: "청구요청 실패!",
            type: "error"
          });
        });
    },

    handlePageChange(page) {
      this.currentPage = page;
    },
    async fetchData() {
      this.searchLoading = true;

      const requestBody = {
        // pagePerCount: this.listQuery.perPageCount,
        pagePerCount: this.perPageCount,
        currentPage: this.currentPage - 1,
        // currentPagePerCount: 0,
        fromDate: this.fromDate,
        toDate: this.toDate,
        orderState: this.orderState,
        reqType: this.reqType,
        dateType: this.dateType,
        keyword: this.keyword
      };
      const excelReq = {
        // pagePerCount: this.listQuery.perPageCount,
        pagePerCount: 1000000,
        currentPage: this.currentPage - 1,
        // currentPagePerCount: 0,
        fromDate: this.fromDate,
        toDate: this.toDate,
        orderState: this.orderState,
        reqType: this.reqType,
        dateType: this.dateType,
        keyword: this.keyword
      };

      await BillingApi.getLotteBillingList(excelReq)
        .then(res => {
          // console.log("오더 리스트 api", res)

          let payload = res.data.payload;
          this.excelTableData = payload.contents;

          this.searchLoading = false;
          //   this.listQuery.currentPage =
          //     payLoad.totalContentCnt === 0 ? 1 : payLoad.currentPage + 1;
          //   this.total = payLoad.totalContentCnt;
          //   this.payload = payLoad.contents;
          //   this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.searchLoading = false;
        });
      return await BillingApi.getLotteBillingList(requestBody)
        .then(res => {
          // console.log("오더 리스트 api", res)

          let payload = res.data.payload;
          this.statusCounts = payload.statusCounts;
          this.tableData = payload.contents;
          this.currentPage =
            payload.totalContentCnt === 0 ? 1 : payload.currentPage + 1;
          this.totalOrderData = payload.totalContentCnt;
          this.searchLoading = false;
          //   this.listQuery.currentPage =
          //     payLoad.totalContentCnt === 0 ? 1 : payLoad.currentPage + 1;
          //   this.total = payLoad.totalContentCnt;
          //   this.payload = payLoad.contents;
          //   this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.searchLoading = false;
        });
    }
  }
};
</script>

<style>
.order-page {
  width: 96vw;
  padding: 24px 0;
  margin: 0 auto;
  background-color: #f6f8fa;
  /* min-height: 100vh; */
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
}

.filter-section {
  border-radius: 12px;
  margin-bottom: 20px;
  background-color: #fff;
}

.filter-header {
  margin-bottom: 12px;
}

.filter-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.date-divider {
  font-weight: bold;
  color: #999;
  margin: 0 4px;
}

.table-section {
  width: 100%;
  border-radius: 12px;
  background-color: #fff;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 0;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
}

/* ✅ 확장(아코디언) 스타일 */
.expand-box {
  padding: 16px;
  background: #fafafa;
  border-top: 1px solid #ebeef5;
  border-radius: 0 0 12px 12px;
}

.expand-title {
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.image-gallery {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.image-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 140px;
}

.img-name {
  font-size: 13px;
  color: #555;
  margin-bottom: 6px;
  text-align: center;
  word-break: keep-all;
}

.preview-img {
  width: 140px;
  height: 140px;
  border-radius: 8px;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.2s ease;
  border: 1px solid #ddd;
}

.preview-img:hover {
  transform: scale(1.05);
}

.no-image {
  font-size: 14px;
  color: #777;
  padding: 12px 0;
}

.status-badges {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 15px;
}

.badge {
  display: inline-block;
  padding: 5px 12px;
  font-size: 13px;
  border-radius: 12px;
  font-weight: 600;
  color: #fff;
}

/* 상태별 색상 */
.badge-default {
  background-color: #9ca3af; /* Gray */
}

.badge-blue {
  background: #3b82f6; /* Blue */
}

.badge-green {
  background-color: #10b981; /* Green */
}

.badge-purple {
  background-color: #8b5cf6; /* Purple */
}

.badge-red {
  background-color: #ef4444; /* Red */
}

.badge-dark {
  background-color: #374151; /* Dark Gray */
}

/* .badge-default {
  background: #9ca3af;

} */

/* 🔵 Blue - 아주 연한 하늘색 */
.el-table .badge-blue > td {
  background: #f5faff !important; /* 거의 흰색에 가까운 연한 파랑 */
  color: #1e3a8a !important;
}

/* 🟢 Green - 연한 민트 */
.el-table .badge-green > td {
  background: #f4fdf8 !important;
  color: #065f46 !important;
}

/* 🟣 Purple - 연한 라벤더 */
.el-table .badge-purple > td {
  background: #faf5ff !important;
  color: #6b21a8 !important;
}

/* 🔴 Red - 연한 핑크 톤 (오류 표시용) */
.el-table .badge-red > td {
  background: #fff5f5 !important;
  color: #b91c1c !important;
}

/* ⚫ Dark (회색) - 최소 강조 */
.el-table .badge-dark > td {
  background: #fafafa !important;
  color: #374151 !important;
}

.el-table .badge-default > td {
  background-color: #e5e7eb !important; /* 연한 회색 */
  color: #374151 !important; /* 회색 글씨 (좀 어두운 느낌) */
}
</style>



// WEBPACK FOOTER //
// src/components/BillingTable.vue